export default Object.freeze({
  add: 'add',
  addMany: 'add-many',
  update: 'update',
  updateMany: 'update-many',
  remove: 'remove',
  removeMany: 'remove-many',
  activate: 'activate',
  deactivate: 'deactivate',
  spCall: 'sp_call',
  query: 'query',
});
